import { PopoverPlacement } from "@idui/react-popover";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { FramerTooltip } from "@ryde/controls";
import { IRideDto } from "@ryde/shared";

import { TabsBottomInfoItemStyled } from "../../../../right";

interface IRidePassengersSeatsInfo {
  rideDto: Partial<IRideDto> | undefined;
}

export const RidePassengersSeatsInfo: FC<IRidePassengersSeatsInfo> = ({
  rideDto,
}) => {
  const { t } = useTranslation();

  const passengersInfo = rideDto?.metadata?.passengersInfo;
  if (!passengersInfo?.length) {
    return null;
  }

  const passengersCount = passengersInfo.length;
  const seatsCount = rideDto?.metadata?.seatsCount || 0;
  const shouldShowBoth = seatsCount > 0 && seatsCount !== passengersCount;

  const passengersLabel =
    passengersCount === 1 ? t("passenger.single") : t("passenger.plural");
  const seatsLabel =
    seatsCount === 1
      ? t("passenger.seats.single")
      : t("passenger.seats.plural");
  const displayCount = seatsCount || passengersCount;
  const displayLabel =
    displayCount === 1 ? t("passenger.single") : t("passenger.plural");

  return (
    <TabsBottomInfoItemStyled>
      <FramerTooltip
        content={t("ride.formLabel.passengerCount")}
        placement={PopoverPlacement.bottom}
      >
        <>
          {shouldShowBoth ? (
            <>
              <label data-e2e="ride-passengers-count" className="info">
                {passengersCount}
              </label>
              <label className="passenger-label">{passengersLabel} (</label>
              <label
                data-e2e="ride-seats-count"
                className="info seats-in-brackets"
              >
                {seatsCount}
              </label>
              <label className="passenger-label">{seatsLabel})</label>
            </>
          ) : (
            <>
              <label data-e2e="ride-passengers-count" className="info">
                {displayCount}
              </label>
              <label className="passenger-label">{displayLabel}</label>
            </>
          )}
        </>
      </FramerTooltip>
    </TabsBottomInfoItemStyled>
  );
};
